var layout_default = {
  "layoutWrapper": "IOdzB",
  "layout": "p0aOa",
  "cell": "ZwVpZ"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
